module.exports = __webpack_public_path__ + "static/media/screenshot.0646b8d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/MakeyourdayShowcasePhone/screenshot.jpg
// module id = 216
// module chunks = 0